import environment from './base';
const baseApi = 'https://services-uat.judiciary.gov.sg';
const env = environment(baseApi);
const config ={
  ...env,
  isProduction: false,
  isDevelopment: false,
  isUAT: true,
};
export default config